import React from 'react';
import { Link } from 'react-router-dom';

import { useEffect } from 'react';
const PrivacyPage = () => {
    useEffect(() => {
  // גלילה חלקה לראש העמוד
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 text-center">מדיניות פרטיות</h1>
          <p className="text-gray-700 text-center mb-6">עודכן לאחרונה: יולי 2025</p>

          <div className="prose prose-lg max-w-none text-right" dir="rtl">
            <p className="text-gray-700 leading-relaxed mb-6">
              מסמך זה מהווה את מדיניות הפרטיות של האתר "גמלנט AI" ("האתר", "השירות", "אנחנו", "מפעיל האתר") ומטרתו להסביר למשתמש ("המשתמש", "אתה") כיצד נאסף, נשמר, מעובד, מועבר ונעשה שימוש במידע אודותיך במהלך שימושך באתר.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              מדיניות זו מנוסחת בהתאם לחוק הגנת הפרטיות, התשמ"א–1981, תקנות הגנת הפרטיות (אבטחת מידע), התשע"ז–2017, הנחיות רשות הגנת הפרטיות, ודין ישראלי מחייב.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              השימוש באתר מהווה הסכמה מלאה, מודעת ומפורשת לכל תנאי מדיניות זו. אם אינך מסכים לה – אנא הימנע מכל שימוש באתר.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. סוגי מידע שנאסף:</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              האתר עשוי לאסוף ולעבד את סוגי המידע הבאים:
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">1.1. מידע שמוסר המשתמש ביוזמתו:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 pr-6">
              <li>שם מלא</li>
              <li>כתובת דוא"ל</li>
              <li>מספר טלפון</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-4">
              המידע נמסר, בין היתר, דרך טופס "צור קשר" באתר לצורך יצירת קשר חוזר על ידי סוכן מורשה בלבד. אין חובת מסירת המידע, אך ייתכן שבלעדיו לא יתאפשר מענה לפנייתך.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">1.2. מידע טכנולוגי ואנליטי:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 pr-6">
              <li>כתובת IP</li>
              <li>סוג דפדפן, מערכת הפעלה ומכשיר</li>
              <li>פעולות באתר (קליקים, זמני שהיה, דפי גלישה)</li>
              <li>מידע שנאסף באמצעות כלים כגון: Microsoft Clarity, Hotjar, Firebase Analytics</li>
            </ul>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">1.3. העדפות או פרופיל פיננסי חלקי (בשלב עתידי בלבד):</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              ייתכן שבעתיד תתאפשר הזנה של העדפות השקעה או פרטים רלוונטיים לצורך דירוג מותאם. כל מידע כזה יהיה וולונטרי בלבד, ואינו ייחשב כהמלצה אישית או כשירות פיננסי.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. מטרות השימוש במידע</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              המידע שנאסף ישמש אך ורק לצרכים הבאים:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 pr-6">
              <li>יצירת קשר יזום עם המשתמש (באמצעות סוכן מורשה בלבד)</li>
              <li>מענה לפניות דרך טפסים באתר</li>
              <li>שיפור תצוגת התכנים והשירותים</li>
              <li>ניתוח התנהגות משתמשים למטרות אבחון תקלות, שיפור חוויית משתמש וייעול ממשקים</li>
              <li>שמירה על אבטחת מידע וניטור פעילות חריגה</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. אופן אחסון המידע</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              המידע נשמר במאגרי נתונים חיצוניים ומאובטחים, לרבות Firebase של Google ו־Google Sheets. הגישה למידע מוגבלת לגורמים מורשים בלבד, תחת הרשאות מגבילות. אין כל אחסון של מידע רגיש (מספרי תעודת זהות, אמצעי תשלום, נתוני בריאות וכיו"ב).
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. מסירת מידע לצדדים שלישיים</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                לא מועבר לצדדים שלישיים מסחריים – למעט במקרים הבאים:
                <ul className="list-disc list-inside text-gray-700 space-y-2 pr-6 mt-2">
                  <li>יצירת קשר עם המשתמש באמצעות סוכן השקעות או ביטוח בעל רישיון – בהתאם למידע שמסר המשתמש.</li>
                  <li>ספקים טכנולוגיים המספקים תשתית תפעולית (Google, Microsoft Clarity, Hotjar) – בכפוף למדיניות שלהם.</li>
                </ul>
              </li>
              <li>
                לא יועבר מידע אישי לכל גורם אחר, אלא:
                <ul className="list-disc list-inside text-gray-700 space-y-2 pr-6 mt-2">
                  <li>לפי דרישת חוק, צו שיפוטי או הוראת רשות מוסמכת.</li>
                  <li>לשם הגנה על זכויות משפטיות של מפעיל האתר.</li>
                  <li>במקרה של מיזוג, רכישה או העברת פעילות האתר – בכפוף לכך שהגורם המקבל יכפיף עצמו לתנאים אלו.</li>
                </ul>
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. אבטחת מידע</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              אנו נוקטים באמצעי אבטחת מידע נאותים בהתאם לנדרש בדין – לרבות גישה מבוקרת, הצפנת מידע (בהתאם ליכולות הפלטפורמה), שימוש בסיסמאות, והפרדה בין שכבות נתונים. יחד עם זאת, המשתמש מאשר ומצהיר כי ידוע לו שאין מערכת אבטחת מידע חסינה לחלוטין מפני חדירות, ומסכים שהשימוש באתר נעשה על אחריותו בלבד.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. שמירת מידע</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              המידע האישי יישמר במאגרי המידע כל עוד יש צורך סביר בכך לשם השגת מטרות המדיניות, ולאחר מכן יימחק או יוסר באופן אנונימי. משתמש רשאי לבקש בכל עת לעיין במידע, לתקנו או לבקש את מחיקתו – בהתאם להוראות סעיף 13 לחוק הגנת הפרטיות.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. זכויות המשתמש</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              בהתאם לחוק, המשתמש רשאי:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 pr-6">
              <li>לעיין במידע השמור עליו</li>
              <li>לדרוש את תיקון המידע או מחיקתו</li>
              <li>להתנגד לעיבוד מידע לצרכי פרסום או פנייה אישית</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-4">
              פנייה בנושא תיענה תוך 30 ימים, ובמידת הצורך – ייתכן שתידרש זיהוי סביר של הפונה.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. רישום מאגר מידע</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              מפעיל האתר מתכוון לרשום מאגר מידע ברשות להגנת הפרטיות, כמחויב לפי החוק. עד להשלמת הרישום, השימוש יתבצע בהתאם לכל הוראות הדין, תוך יידוע המשתמשים והקפדה על אבטחת המידע.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">9. מידע אנונימי</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              האתר עשוי להשתמש במידע אנונימי או מצרפי לצרכים סטטיסטיים, מחקריים, שיפור שירותים או פיתוח עתידי. מידע כזה אינו מזהה אישית את המשתמש ואינו כפוף להגבלות פרטיות.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">10. שינויים במדיניות</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              מפעיל האתר שומר לעצמו את הזכות לעדכן מדיניות זו מעת לעת, לפי שיקול דעתו וללא הודעה מוקדמת. נוסח מעודכן יפורסם באתר ויחול עם פרסומו. המשך שימוש באתר מהווה הסכמה לנוסח המעודכן.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">11. יצירת קשר</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              לכל שאלה, פנייה או בקשה הנוגעת למדיניות פרטיות זו – ניתן לפנות דרך{' '}
              <Link to="/contact" className="text-blue-600 hover:text-blue-800">טופס "צור קשר" שבאתר</Link>.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">12. דיוור שיווקי ומסרים ישירים</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                נכון למועד זה, האתר אינו שולח מסרים שיווקיים, ניוזלטרים, פרסומות או הצעות מסחריות מכל סוג שהוא.
              </li>
              <li>
                יובהר כי ככל שתתבצע בעתיד פעילות של דיוור שיווקי או משלוח הצעות ישירות למשתמש – פעולה זו תיעשה אך ורק בהתאם לדין, לרבות הוראות חוק התקשורת (בזק ושידורים), התשמ"ב–1982 (סעיף 30א), ובהסתמך על:
                <ul className="list-disc list-inside text-gray-700 space-y-2 pr-6 mt-2">
                  <li>הסכמה מפורשת ומודעת מראש מצד המשתמש (opt-in)</li>
                  <li>יכולת הסרה ברורה ופשוטה בכל הודעה</li>
                  <li>שימוש מבוקר ומוגבל בפרטי המשתמש (שם, מייל, טלפון)</li>
                </ul>
              </li>
              <li>
                המשתמש רשאי לבטל בכל עת את הסכמתו לדיוור, בין אם באמצעות מנגנון ההסרה שיצורף להודעות, ובין אם על ידי פנייה דרך טופס "צור קשר" באתר.
              </li>
              <li>
                מפעיל האתר מתחייב שלא להעביר פרטי התקשרות של משתמשים לגורמים חיצוניים לצורכי פרסום, שיווק, קידום מכירות או כל מטרה דומה – אלא באישור נפרד, כתוב ומפורש מצד המשתמש.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;